<template>
  <div>
    <div class="card card-custom card-sticky" v-if="!mostrarDetalleFicha">
      <div class="card-header">
        <div class="card-title">
          <h3 class="card-label cursor-pointer">
            <span class="label label-xl label-dot label-danger mr-2"></span> Turno 2 - Mesa <i class="mr-2"></i>
            <small v-if="ui.estaCargandoDatos">Cargando datos de la ficha...</small>
            <small v-else-if="auth.mensajeNoAutorizadoEdicionTurno" class="text-danger">{{ auth.mensajeNoAutorizadoEdicionTurno }}</small>
          </h3>
        </div>
        <div class="card-toolbar">
          <a href="#" class="btn btn-sm btn-light font-weight-bold" @click.prevent="doCargarFicha()"><i class="fa p-0 fa-sync" :class="[ui.estaCargandoDatos ? 'fa-spin ' : '']"></i></a>
        </div>
      </div>
    </div>
    <div class="card card-custom card-sticky" v-if="mostrarDetalleFicha">
      <div class="card-header">
        <div class="card-title">
          <h3 class="card-label cursor-pointer" @click.prevent="$emit('update:expandirContenido', !expandirContenido)">
            <span class="label label-xl label-dot label-danger mr-2"></span> Turno 2 - Mesa <i class="mr-2"></i>
            <small>{{ auth.fechaInicioTurno | time }} - {{ auth.fechaFinTurno | time }}</small>
          </h3>
        </div>
        <div class="card-toolbar">
          <a href="#" class="btn btn-sm font-weight-bold mr-2" :class="isDirty ? 'btn-success' : 'btn-light-success'" @click.prevent="doGuardado()"><i class="fa" :class="[ui.estaGuardando ? 'fa-spinner fa-spin p-0 fa-align-center mr-1' : 'fa-save']"></i> Guardar cambios</a>

          <a href="#" class="btn btn-sm btn-light-warning font-weight-bold" @click.prevent="$emit('update:expandirContenido', !expandirContenido)"><i class="fa p-0" :class="[expandirContenido ? 'fa-chevron-up' : 'fa-chevron-down']"></i></a>
        </div>
      </div>
      <div class="card-body" v-show="expandirContenido">
        <form class="form" id="frm-mesa-turno-2">
          <div class="row">
            <div class="col-xl-2"></div>
            <div class="col-xl-8">

              <div class="my-5">
                <h3 class=" text-dark font-weight-bold mb-10">II. Seguimiento a la votación</h3>

                <!-- 2.1 -->
                <div class="form-group row">
                  <label :class="ui.colLeftClass">2.1. Número de mesa de votación:</label>
                  <div :class="ui.colRightClass">
                    <input type="text" class="form-control" v-model="actual.t2NumeroMesa" placeholder="Número de mesa de votación..." />
                  </div>
                </div>

                <!-- 2.2 -->
                <div class="form-group row">
                  <label :class="ui.colLeftClass">2.2. Hora de la observación:</label>
                  <div :class="ui.colRightClass">
                    <input type="time" class="form-control" v-model="actual.t2HoraObservacion" />
                  </div>
                </div>

                <!-- 2.3 -->
                <div class="form-group row">
                  <label :class="ui.colLeftClass">2.3. ¿Cuántas personas han votado?</label>
                  <div :class="ui.colRightClass">
                    <input type="number" min="0" class="form-control" v-model="actual.t2NroPersonasVotaron" placeholder="Número de personas que han votado..." />
                  </div>
                </div>

                <!-- 2.4 -->
                <div class="form-group row">
                  <label :class="ui.colLeftClass">2.4. ¿Cuántos electores están registrados en esta mesa?</label>
                  <div :class="ui.colRightClass">
                    <input type="number" min="0" class="form-control" v-model="actual.t2NroElectoresHabilesMesa" placeholder="Número de electores registrados..." />
                  </div>
                </div>

                <!-- 2.5 -->
                <div class="form-group row">
                  <label :class="ui.colLeftClass">2.5. Consultar a los miembros de mesa si hay firma(s) en la ZONA SOMBREADA COMO FALLECIDOS</label>
                  <div :class="ui.colRightClass">
                    <div class="btn-group btn-group" role="group">
                      <button type="button" @click.prevent="actual.t2HayFirmasZonaSombreadaFallecidos = true" class="btn" :class="[actual.t2HayFirmasZonaSombreadaFallecidos === true ? 'btn-success' : 'btn-outline-secondary']">Sí</button>
                      <button type="button" @click.prevent="actual.t2HayFirmasZonaSombreadaFallecidos = false" class="btn" :class="[actual.t2HayFirmasZonaSombreadaFallecidos === false ? 'btn-danger' : 'btn-outline-secondary']">No</button>
                    </div>
                    <textarea v-if="actual.t2HayFirmasZonaSombreadaFallecidos === true" v-model="actual.t2HayFirmasZonaSombreadaFallecidosDetalle" class="form-control mt-2" type="text" placeholder="Indique detalle..." required></textarea>
                  </div>
                </div>
              </div>

            </div>
            <div class="col-xl-2"></div>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<style scoped>
.table-hover tbody tr:hover {
  background-color: #f9f9f9;
}
</style>

<script>
import Swal from "sweetalert2";

export default {
  name: "ficha-turno-2-mesa",
  components: {},
  props: {
    mesaVotacionId: {
      type: Number,
    },
    procesoElectoralId: {
      type: Number,
    },
    expandirContenido: {
      type: Boolean,
    },
    intervaloAutoGuardado: {
      type: Number,
    },
  },
  data: () => ({
    auth: {
      autorizadoEdicionTurno: null,
      mensajeNoAutorizadoEdicionTurno: null,
      puedeCambiarEstadoFinalizado: null,
      puedeEditarTurno: null,
      puedeVisualizarTurno: null,
      puedeFinalizarTurno: null,
      puedeReanudarTurno: null,
      fechaInicioTurno: null,
      fechaFinTurno: null,
      fechaInicioEdicionTurno: null,
      fechaFinEdicionTurno: null,
    },
    ui: {
      colLeftClass: "col-sm-12 col-md-5",
      colRightClass: "col-sm-12 col-md-7",
      estaGuardando: false,
      estaCargandoDatos: false,
      tieneCargaInicial: false,
    },
    temporizadorGuardado: null,
    numeroMesaEsperado: null,
    actual: {
      t2NumeroMesa: null,
      t2HoraObservacion: null,
      t2NroPersonasVotaron: null,
      t2NroElectoresHabilesMesa: null,
      t2HayFirmasZonaSombreadaFallecidos: null,
      t2HayFirmasZonaSombreadaFallecidosDetalle: null,
    },
    guardado: {
      t2NumeroMesa: null,
      t2HoraObservacion: null,
      t2NroPersonasVotaron: null,
      t2NroElectoresHabilesMesa: null,
      t2HayFirmasZonaSombreadaFallecidos: null,
      t2HayFirmasZonaSombreadaFallecidosDetalle: null,
    },
  }),
  computed: {
    isDirty: function() {
      return JSON.stringify(this.actual) != JSON.stringify(this.guardado);
    },
    mostrarDetalleFicha: function() {
      if (!this.ui.tieneCargaInicial) return false;
      if (!this.auth.autorizadoEdicionTurno) return false;
      return true;
    },
  },
  methods: {
    inicializarGuardado: function() {
      var vm = this;
      clearTimeout(this.temporizadorGuardado);
      this.temporizadorGuardado = setTimeout(function() {
        if (vm.isDirty) {
          vm.doGuardado();
        }
      }, this.intervaloAutoGuardado);
    },
    doCargarFicha: async function() {
      this.ui.estaCargandoDatos = true;
      var model = {
        mesaVotacionId: this.mesaVotacionId,
        procesoElectoralId: this.procesoElectoralId,
      };

      await this.$http.post(this.apiRoute("Sheet", "GetFichaMesaTurnoDos"), model).then(function(response) {
        if (!this.procesarRespuestaErrorDefecto(response)) {
          var ficha = response.body.data.ficha;

          var tempActual = this.cloneObject(this.actual);
          var tempGuardado = this.cloneObject(this.guardado);

          tempActual.t2NumeroMesa = this.actualizarBaseDiferente("t2NumeroMesa", tempActual, tempGuardado, ficha);
          tempActual.t2HoraObservacion = this.actualizarBaseDiferente("t2HoraObservacion", tempActual, tempGuardado, ficha);
          tempActual.t2NroPersonasVotaron = this.actualizarBaseDiferente("t2NroPersonasVotaron", tempActual, tempGuardado, ficha);
          tempActual.t2NroElectoresHabilesMesa = this.actualizarBaseDiferente("t2NroElectoresHabilesMesa", tempActual, tempGuardado, ficha);
          tempActual.t2HayFirmasZonaSombreadaFallecidos = this.actualizarBaseDiferente("t2HayFirmasZonaSombreadaFallecidos", tempActual, tempGuardado, ficha);
          tempActual.t2HayFirmasZonaSombreadaFallecidosDetalle = this.actualizarBaseDiferente("t2HayFirmasZonaSombreadaFallecidosDetalle", tempActual, tempGuardado, ficha);

          this.actual = this.cloneObject(tempActual);
          this.guardado = this.cloneObject(this.actual);
          this.auth = response.body.data.auth;
          this.numeroMesaEsperado = response.body.data.numeroMesaEsperado;
          this.inicializarGuardado();
        }
      }, this.mostrarMensajeExcepcionVueResource);

      this.ui.tieneCargaInicial = true;
      this.ui.estaCargandoDatos = false;
    },
    actualizarBaseDiferente: function(propiedad, fichaActual, fichaGuardado, fichaActualizada) {
      var valorActual = JSON.stringify(fichaActual[propiedad]);
      var valorGuardado = JSON.stringify(fichaGuardado[propiedad]);
      var valorActualizado = JSON.stringify(fichaActualizada[propiedad]);

      if (valorActual == valorGuardado && valorGuardado != valorActualizado) {
        return fichaActualizada[propiedad];
      } else {
        return fichaActual[propiedad];
      }
    },
    doGuardado: async function(omitirNotificacion) {
      if (this.ui.estaGuardando) return;

      var numeroIngresado = (this.actual.t2NumeroMesa != null ? String(this.actual.t2NumeroMesa) : "").trim();
      if (!numeroIngresado) {
        if (omitirNotificacion != true) {
          Swal.fire({
            icon: "warning",
            title: "Número de mesa requerido",
            text: "Debe ingresar el número de mesa para poder guardar los datos.",
          });
        }
        return false;
      }
      var numeroEsperado = (this.numeroMesaEsperado != null ? String(this.numeroMesaEsperado) : "").trim();
      if (numeroEsperado && numeroIngresado !== numeroEsperado) {
        if (omitirNotificacion != true) {
          Swal.fire({
            icon: "error",
            title: "Número de mesa incorrecto",
            text: "El número de mesa ingresado no corresponde a la mesa que se está evaluando. Se espera la mesa N° " + numeroEsperado + ".",
          });
        }
        return false;
      }

      if (!this.isFormValid("frm-mesa-turno-2")) {
        if (omitirNotificacion != true) {
          this.$bvToast.toast("Hay campos con valores incorrectos. Revise los datos ingresados.", {
            title: "Turno 2 - Mesa",
            autoHideDelay: 5000,
            variant: "warning",
            appendToast: false,
            solid: true,
          });
          return false;
        }
      }

      var actualClone = this.cloneObject(this.actual);

      var model = this.cloneObject(this.actual);
      model.mesaVotacionId = this.mesaVotacionId;
      model.procesoElectoralId = this.procesoElectoralId;

      var guardadoExistoso = false;
      this.ui.estaGuardando = true;
      await this.$http.post(this.apiRoute("Sheet", "EditFichaMesaTurnoDos"), model).then(function(response) {
        if (!this.procesarRespuestaErrorDefecto(response)) {
          this.guardado = actualClone;

          if (omitirNotificacion != true) {
            this.$bvToast.toast("Los cambios se han guardado correctamente.", {
              title: "Turno 2 - Mesa",
              autoHideDelay: 5000,
              variant: "success",
              appendToast: false,
              solid: true,
            });
          }
          guardadoExistoso = true;
        }
      }, this.mostrarMensajeExcepcionVueResource);

      this.ui.estaGuardando = false;
      return guardadoExistoso;
    },
  },
  watch: {
    actual: {
      deep: true,
      handler() {
        if (this.intervaloAutoGuardado && !this.ui.estaCargandoDatos) {
          this.inicializarGuardado();
        }
      },
    },
  },
  mounted: function() {
    this.initParsley();
    this.doCargarFicha();
  },
  destroyed: function() {
    clearTimeout(this.temporizadorGuardado);
  },
};
</script>
